import { useMobileIntentOnboardingRollout } from './experiments';

const DESKTOP_ONBOARDING_PATH = '/app/onboarding';
const MOBILE_ONBOARDING_PATH = '/app/welcome';

export const useOnboardingPageRouting = (): {
  onboardingPath: string;
} => {
  //TODO: remove this when the rollout is completed
  const shouldShowMobileIntentOnboarding = useMobileIntentOnboardingRollout();
  if (shouldShowMobileIntentOnboarding) {
    return {
      onboardingPath: MOBILE_ONBOARDING_PATH,
    };
  } else
    return {
      onboardingPath: DESKTOP_ONBOARDING_PATH,
    };
};
